import * as React from "react";
import { Dropdown, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { ILookupDictionary } from "../../../../lookup/types/ILookupDictionary";
import { updateUsagePoolField } from "../../../../redux/reducers/RepertoireReducer";
import IRepertoireComponentDataItem from "../../../../redux/types/IRepertoireComponentDataItem";
import { ITabReduxItem } from "../../../../redux/types/ITabReduxItem";
import CheckboxDataInput, { SizedCheckboxDataInput } from "../../../components/checkboxDataInput/CheckboxDataInput";
import { SizedTextDataInput } from "../../../components/textDataInput/TextDataInput";
import { DROPDOWN_INPUT, INTEGER_INPUT, INTEGER_PERCENTAGE_INPUT, MULTI_SELECT_DROPDOWN, POOL_ALLOCATE_SPECIFIC_ROLES_STATE_KEY, POOL_ALLOCATE_SPECIFIC_SOCIETIES_STATE_KEY, POOL_ALLOCATION_SETTINGS_KEY, POOL_ARRANGERS_OOC_SHARE_CALC_STATE_KEY, POOL_CUSTOM_NOTEBOOK_STATE_KEY, POOL_DEDUCT_COMMISSION_PERCENTAGE_STATE_KEY, POOL_DEFAULT_DURATION_PERCENTAGE_STATE_KEY, POOL_EXCLUDE_LIBRARY_WORKS_STATE_KEY, POOL_EXCLUDE_PRODUCT_WORKS_STATE_KEY, POOL_MISSING_SHARES_STATE_KEY, POOL_NON_SOCIETY_IPS_STATE_KEY, POOL_NON_SOCIETY_PUBLISHER_REDIRECT_STATE_KEY, POOL_PD_ARRANGEMENT_SHARE_CALC_STATE_KEY, POOL_PD_IPS_STATE_KEY, POOL_PD_WORK_PERCENT_STATE_KEY, POOL_PERCENTAGE_DURATION_STATE_KEY, POOL_RECIPROCAL_AGREEMENTS_STATE_KEY, POOL_REFERENCE_IPS_STATE_KEY, POOL_RIGHT_TYPE_REDIRECT_STATE_KEY, POOL_UNIDENTIFIED_USAGE_STATE_KEY, POOL_WARSAW_RULE_STATE_KEY, REPERTOIRE_PAGE_FORM_ITEM_SIZE, TEXT_INPUT, USE_ADVERTISEMENT_DURATION_FOR_MATCHED_USAGE, USE_CUE_SHEET_DURATION_FOR_MATCHED_USAGE, USE_WEIGHT_AS_AMOUNT_STATE_KEY } from "../../../Consts";
import { IRepertoireStateKeys } from "../../../types/IRepertoireStateKeys";
import { IUsagePoolAllocationSettingsDataItems } from "../../../types/usageTypes/IUsagePoolAllocationSettingsDataItems";
import { getLookupDefault, getLookupDefaultMultiSelect, getLookupDefaultV2, getLookupValues } from "../../../../lookup/services/LookupHelpers";
import { AGENCY_LOOKUP, SET_TYPE_RIGHTS_LOOKUP, WORK_CONTRIBUTOR_TYPE_LOOKUP } from "../../../../lookup/Consts";
import ToggleInputCheckbox from "../../../components/usageComponents/toggleInputField/ToggleInputCheckbox";
import { POOL } from "../../../../home/components/modalViews/uuiFormFieldsView/UUIFormFieldsView";

export interface IPoolMaintenanceAllocationSettingsGridProps {
    allocationSettingsGridViewData?: IRepertoireComponentDataItem;
    isReadonly: boolean;
    poolAllocationSettings: IUsagePoolAllocationSettingsDataItems;
    updateUsagePoolField: typeof updateUsagePoolField;
    activeTab?: number;
    tabs?: ITabReduxItem[];
    lookupValues: ILookupDictionary;
}

export interface IPoolMaintenanceAllocationSettingsGridState {
    loaded: boolean;
    isAllocateSpecificRoles: boolean;
    isAllocateSpecificSocieties : boolean;
    isDeductCommission : boolean;
    rolesType: any[];
    societiesType: any[];
    rightType: any[];
    isRightTypeRedirect: boolean;
}

export default class PoolMaintenanceAllocationSettingsGrid extends React.Component<IPoolMaintenanceAllocationSettingsGridProps, IPoolMaintenanceAllocationSettingsGridState>{
    viewData;
    constructor(props: IPoolMaintenanceAllocationSettingsGridProps) {
        super(props);
        this.state = { 
            loaded: false,
            isAllocateSpecificRoles: false,
            isAllocateSpecificSocieties: false,
            isDeductCommission: false,
            rolesType: [],
            societiesType: [],
            rightType: [],
            isRightTypeRedirect: false
        };
        
        this.viewData = {};
    }


    componentDidMount() {
        const {
            allocationSettingsGridViewData: { fields },
            poolAllocationSettings
        } = this.props;

        if (fields) {
            let visibleFields = fields.filter(field => !field.hidden);

            visibleFields.forEach(item => {
                this.viewData[item.name] = item.data;

                if (Object.keys(this.viewData).length === visibleFields.length) {
                    this.setState({ loaded: true });
                }
            });
        }

        if (poolAllocationSettings.allocateSpecificRoles.value) {
            this.setState({ 
                isAllocateSpecificRoles: poolAllocationSettings.allocateSpecificRoles.value.length > 0  
            });
        }

        if (poolAllocationSettings.allocateSpecificSocieties.value) {
            this.setState({ 
                isAllocateSpecificSocieties: poolAllocationSettings.allocateSpecificSocieties.value.length > 0  
            });
        }
        
        if (poolAllocationSettings.deductCommissionPercentage.value){
            this.setState({ 
                isDeductCommission: true
            });
        }

        if (poolAllocationSettings.rightTypeRedirect.value){
            this.setState({ 
                isRightTypeRedirect: true
            });
        }
    }

    render() {
        if (!this.state.loaded)
            return null;

        const flexColumn = {
            display: 'flex',
            flexDirection: 'column',
            height: '100%'
        };

        const dropdownContainer = {
            marginTop: '10px'
        };

        const { 
            poolAllocationSettings, 
            isReadonly,
            lookupValues,
            allocationSettingsGridViewData
        } = this.props;

        const lookupWorkContributorsTypeVals = getLookupValues(WORK_CONTRIBUTOR_TYPE_LOOKUP, lookupValues);
        const lookupAgencyTypeVals = getLookupValues(AGENCY_LOOKUP, lookupValues);
        const lookupSetTypeRightsVals = getLookupValues(SET_TYPE_RIGHTS_LOOKUP, lookupValues);

        const {
            unidentifiedUsage,
            nonSocietyIPs,
            referenceIPs,
            missingShares,
            warsawRule,
            percentageDurationForUnidentifiedUsage,
            defaultDurationPercentage,
            reciprocalAgreements,
            pdWork100Percent,
            pdiPs,
            pdArrangementShareCalc,
            arrangersOOCShareCalc,
            useCueSheetDurationForMatchedUsage,
            useAdvertisementDurationForMatchedUsage,
            customNotebook,
            allocateSpecificRoles,
            allocateSpecificSocieties,
            nonSocietyPublisherRedirect,
            excludeLibraryWorks,
            deductCommissionPercentage,
            rightTypeRedirect,
            useWeightAsAmount,
            excludeProductWorks,
        } = poolAllocationSettings;

        const { 
            isAllocateSpecificRoles, 
            isAllocateSpecificSocieties, 
            isDeductCommission,
            rolesType, 
            societiesType,
            isRightTypeRedirect,
            rightType
        } = this.state;

        const rolesOptions = [];
        const societiesOptions = [];
        const rightTypeRedirectOptions = [];

        if (allocateSpecificRoles.value) {
            allocateSpecificRoles.value.forEach(item => {
                const id = lookupWorkContributorsTypeVals.filter(x => x.code === item)[0].typeID;
                if (!rolesType.includes(id)) {
                    rolesType.push(id);
                };
            });
        }

        if (allocateSpecificSocieties.value) {
            allocateSpecificSocieties.value.forEach(item => {
                if (!societiesType.includes(item)) {
                    societiesType.push(item);
                };
            });
        }

        if(rightTypeRedirect.value){
            rightType[0] = rightTypeRedirect.value;
        }

        if(lookupWorkContributorsTypeVals){
            lookupWorkContributorsTypeVals.forEach(x => rolesOptions.push({ key: x.typeID, text: x.description , data: x.code }));
        }
        
        if(lookupAgencyTypeVals){
            lookupAgencyTypeVals.sort((a, b) => a.description.localeCompare(b.description))
            .forEach(x => societiesOptions.push({ key: x.code, text: x.description, data: x.description }));
        }

        if (lookupSetTypeRightsVals) {
            const validCode = ['RB', 'TB', 'MR'];
            lookupSetTypeRightsVals
            .filter(x => validCode.includes(x.code))
            .sort((a, b) => a.description.localeCompare(b.description))
            .forEach(x => rightTypeRedirectOptions.push({ key: x.code, text: `${x.code} - ${x.description}`, data: x.description }));
        }

        const changeData = (value: any, name: IRepertoireStateKeys, isOnBlur?: boolean) => {

            const { updateUsagePoolField } = this.props;
            poolAllocationSettings[name].value = value;
            updateUsagePoolField(poolAllocationSettings, POOL_ALLOCATION_SETTINGS_KEY);
        }

         const selectChangeRedirectTypeRight = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
            
            if (rightType.includes(option.key)) {
                rightType[0] = null;
            }else{
                rightType[0] = option.key;
            }
            
            changeData(rightType[0], POOL_RIGHT_TYPE_REDIRECT_STATE_KEY);
        }

        const multiSelectChangeSocietiesData = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
            
            if (!societiesType.includes(option.key)) {
                societiesType.push(option.key)
            }
            else {
                const index = societiesType.indexOf(option.key);
                if (index > -1) {
                    societiesType.splice(index, 1);
                }
            }
            changeData(societiesType, POOL_ALLOCATE_SPECIFIC_SOCIETIES_STATE_KEY);
        }

        const multiSelectChangeRoleData = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption, index?: number) => {
                
            if (!rolesType.includes(option.key)) {
                rolesType.push(option.key)
            }
            else {
                const index = rolesType.indexOf(option.key);
                if (index > -1) {
                    rolesType.splice(index, 1);
                }
            }
                
            const arrayCode =  rolesType.map(item => lookupWorkContributorsTypeVals.filter(x => x.typeID === item)[0].code);
            changeData(arrayCode, POOL_ALLOCATE_SPECIFIC_ROLES_STATE_KEY);
        }

        const handleIsAllocateSpecificRoles = (val: boolean, name: string) => {
            this.setState({ isAllocateSpecificRoles: val });

            if(!val){
                this.setState({ rolesType: []});
                changeData([], name);
            }
        }

        const handleIsAllocateSpecificSocieties = (val: boolean, name: string) => {
            this.setState({ isAllocateSpecificSocieties: val });

            if(!val){
                this.setState({ societiesType: []});
                changeData([], name);
            }
        }

        const handleIsRightTypeRedirect = (val: boolean, name: string) => {
            this.setState({ isRightTypeRedirect: val });

            if(!val){
                this.setState({ rightType: []});
                changeData(null, name);
            }
        }

        const handleOnCheckedDeductCommission = (val: boolean, name: string) => {
            this.setState({ isDeductCommission: val });

            if(!val)
                changeData(null, name)
        }

        return (
            <>
                <div className="row tableContainer">
                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_UNIDENTIFIED_USAGE_STATE_KEY]}
                        fieldName={POOL_UNIDENTIFIED_USAGE_STATE_KEY}
                        value={unidentifiedUsage.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_UNIDENTIFIED_USAGE_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_NON_SOCIETY_IPS_STATE_KEY]}
                        fieldName={POOL_NON_SOCIETY_IPS_STATE_KEY}
                        value={nonSocietyIPs.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_NON_SOCIETY_IPS_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_REFERENCE_IPS_STATE_KEY]}
                        fieldName={POOL_REFERENCE_IPS_STATE_KEY}
                        value={referenceIPs.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_REFERENCE_IPS_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_MISSING_SHARES_STATE_KEY]}
                        fieldName={POOL_MISSING_SHARES_STATE_KEY}
                        value={missingShares.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_MISSING_SHARES_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_WARSAW_RULE_STATE_KEY]}
                        fieldName={POOL_WARSAW_RULE_STATE_KEY}
                        value={warsawRule.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_WARSAW_RULE_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_RECIPROCAL_AGREEMENTS_STATE_KEY]}
                        fieldName={POOL_RECIPROCAL_AGREEMENTS_STATE_KEY}
                        value={reciprocalAgreements.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_RECIPROCAL_AGREEMENTS_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_PD_WORK_PERCENT_STATE_KEY]}
                        fieldName={POOL_PD_WORK_PERCENT_STATE_KEY}
                        value={pdWork100Percent.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_PD_WORK_PERCENT_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_PD_IPS_STATE_KEY]}
                        fieldName={POOL_PD_IPS_STATE_KEY}
                        value={pdiPs.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_PD_IPS_STATE_KEY]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_PD_ARRANGEMENT_SHARE_CALC_STATE_KEY]}
                        fieldName={POOL_PD_ARRANGEMENT_SHARE_CALC_STATE_KEY}
                        value={pdArrangementShareCalc.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_PD_ARRANGEMENT_SHARE_CALC_STATE_KEY]} />

                    
                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_ARRANGERS_OOC_SHARE_CALC_STATE_KEY]}
                        fieldName={POOL_ARRANGERS_OOC_SHARE_CALC_STATE_KEY}
                        value={arrangersOOCShareCalc.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_ARRANGERS_OOC_SHARE_CALC_STATE_KEY]} />


                    <SizedCheckboxDataInput
                        label={this.viewData[USE_CUE_SHEET_DURATION_FOR_MATCHED_USAGE]}
                        fieldName={USE_CUE_SHEET_DURATION_FOR_MATCHED_USAGE}
                        value={useCueSheetDurationForMatchedUsage.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[USE_CUE_SHEET_DURATION_FOR_MATCHED_USAGE]} />

                    <SizedCheckboxDataInput
                        label={this.viewData[USE_ADVERTISEMENT_DURATION_FOR_MATCHED_USAGE]}
                        fieldName={USE_ADVERTISEMENT_DURATION_FOR_MATCHED_USAGE}
                        value={useAdvertisementDurationForMatchedUsage.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[USE_ADVERTISEMENT_DURATION_FOR_MATCHED_USAGE]} />
                    
                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_NON_SOCIETY_PUBLISHER_REDIRECT_STATE_KEY]}
                        fieldName={POOL_NON_SOCIETY_PUBLISHER_REDIRECT_STATE_KEY}
                        value={nonSocietyPublisherRedirect.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_NON_SOCIETY_PUBLISHER_REDIRECT_STATE_KEY]} />
                    
                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_EXCLUDE_LIBRARY_WORKS_STATE_KEY]}
                        fieldName={POOL_EXCLUDE_LIBRARY_WORKS_STATE_KEY}
                        value={excludeLibraryWorks.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_EXCLUDE_LIBRARY_WORKS_STATE_KEY]} />
                    
                    <div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE} style={flexColumn as React.CSSProperties}> 
                        <CheckboxDataInput
                                    label={this.viewData[POOL_PERCENTAGE_DURATION_STATE_KEY]}
                                    fieldName={POOL_PERCENTAGE_DURATION_STATE_KEY}
                                    value={percentageDurationForUnidentifiedUsage.value}
                                    changeData={changeData}
                                    readonly={isReadonly}
                                    isHidden={!this.viewData[POOL_PERCENTAGE_DURATION_STATE_KEY]} 
                        />

                        {percentageDurationForUnidentifiedUsage.value ?
                        <div style={dropdownContainer as React.CSSProperties}>
                            <SizedTextDataInput
                                label={this.viewData[POOL_DEFAULT_DURATION_PERCENTAGE_STATE_KEY]}
                                fieldName={POOL_DEFAULT_DURATION_PERCENTAGE_STATE_KEY}
                                changeData={changeData}
                                value={defaultDurationPercentage.value}
                                isHidden={!this.viewData[POOL_DEFAULT_DURATION_PERCENTAGE_STATE_KEY]}
                                fieldType={INTEGER_INPUT}
                                readOnly={isReadonly}
                                minValueForNumericField={0}
                            />
                        </div>
                        : <> </>}
                    </div>

                    <ToggleInputCheckbox
                        label={this.viewData[POOL_ALLOCATE_SPECIFIC_ROLES_STATE_KEY]}
                        fieldName={POOL_ALLOCATE_SPECIFIC_ROLES_STATE_KEY}
                        checked={isAllocateSpecificRoles}
                        onChecked={handleIsAllocateSpecificRoles}
                        isReadOnly={isReadonly}
                        isHidden={!this.viewData[POOL_ALLOCATE_SPECIFIC_ROLES_STATE_KEY]}
                        onChange={multiSelectChangeRoleData}
                        placeholder={"No Role selected."}
                        componentStyles={{
                            title: { height: 40, backgroundColor: "WhiteSmoke", borderWidth: 1, borderColor: "LightGray", padding: 4 }
                        }}
                        fieldType={MULTI_SELECT_DROPDOWN}
                        options={rolesOptions}
                        selectedKeys={rolesType ? rolesType as any : getLookupDefaultMultiSelect(lookupValues, WORK_CONTRIBUTOR_TYPE_LOOKUP, POOL_ALLOCATE_SPECIFIC_ROLES_STATE_KEY, allocationSettingsGridViewData)}
                    
                    />
                    <ToggleInputCheckbox
                        label={this.viewData[POOL_ALLOCATE_SPECIFIC_SOCIETIES_STATE_KEY]}
                        fieldName={POOL_ALLOCATE_SPECIFIC_SOCIETIES_STATE_KEY}
                        checked={isAllocateSpecificSocieties}
                        onChecked={handleIsAllocateSpecificSocieties}
                        isReadOnly={isReadonly}
                        isHidden={!this.viewData[POOL_ALLOCATE_SPECIFIC_SOCIETIES_STATE_KEY]}
                        onChange={multiSelectChangeSocietiesData}
                        placeholder={"No Society selected."}
                        componentStyles={{
                            title: { height: 40, backgroundColor: "WhiteSmoke", borderWidth: 1, borderColor: "LightGray", padding: 4 }
                        }}
                        fieldType={MULTI_SELECT_DROPDOWN}
                        options={societiesOptions}
                        selectedKeys={societiesType ? societiesType as any : getLookupDefaultMultiSelect(lookupValues, AGENCY_LOOKUP, POOL_ALLOCATE_SPECIFIC_SOCIETIES_STATE_KEY, allocationSettingsGridViewData)}
                    />
                    <ToggleInputCheckbox
                        label={this.viewData[POOL_DEDUCT_COMMISSION_PERCENTAGE_STATE_KEY]}
                        fieldName={POOL_DEDUCT_COMMISSION_PERCENTAGE_STATE_KEY}
                        checked={isDeductCommission}
                        onChecked={handleOnCheckedDeductCommission}
                        isReadOnly={isReadonly}
                        isHidden={!this.viewData[POOL_DEDUCT_COMMISSION_PERCENTAGE_STATE_KEY]}
                        onChange={changeData}
                        fieldType={INTEGER_PERCENTAGE_INPUT}
                        value={deductCommissionPercentage.value}
                        onClick={e => e.currentTarget.select()}
                    />
                    <SizedCheckboxDataInput
                        label={this.viewData[USE_WEIGHT_AS_AMOUNT_STATE_KEY]}
                        fieldName={USE_WEIGHT_AS_AMOUNT_STATE_KEY}
                        value={useWeightAsAmount.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[USE_WEIGHT_AS_AMOUNT_STATE_KEY]} />
                    
                    <ToggleInputCheckbox
                        label={this.viewData[POOL_RIGHT_TYPE_REDIRECT_STATE_KEY]}
                        fieldName={POOL_RIGHT_TYPE_REDIRECT_STATE_KEY}
                        checked={isRightTypeRedirect}
                        onChecked={handleIsRightTypeRedirect}
                        isReadOnly={isReadonly}
                        isHidden={!this.viewData[POOL_RIGHT_TYPE_REDIRECT_STATE_KEY]}
                        onChange={selectChangeRedirectTypeRight}
                        placeholder={"No Right type selected."}
                        componentStyles={{
                            title: { height: 40, backgroundColor: "WhiteSmoke", borderWidth: 1, borderColor: "LightGray", padding: 4 }
                        }}
                        options={rightTypeRedirectOptions}
                        fieldType={MULTI_SELECT_DROPDOWN}
                        selectedKeys={rightType ? rightType as any : getLookupDefaultMultiSelect(lookupValues,SET_TYPE_RIGHTS_LOOKUP, POOL_RIGHT_TYPE_REDIRECT_STATE_KEY, allocationSettingsGridViewData) }
                    />
                    <SizedCheckboxDataInput
                        label={this.viewData[POOL_EXCLUDE_PRODUCT_WORKS_STATE_KEY]}
                        fieldName={POOL_EXCLUDE_PRODUCT_WORKS_STATE_KEY}
                        value={excludeProductWorks.value}
                        changeData={changeData}
                        readonly={isReadonly}
                        isHidden={!this.viewData[POOL_EXCLUDE_PRODUCT_WORKS_STATE_KEY]} />
                </div>
                <div className="row tableContainer">
                    <SizedTextDataInput
                        label={this.viewData[POOL_CUSTOM_NOTEBOOK_STATE_KEY]}
                        fieldName={POOL_CUSTOM_NOTEBOOK_STATE_KEY}
                        changeData={changeData}
                        value={customNotebook.value}
                        isHidden={!this.viewData[POOL_CUSTOM_NOTEBOOK_STATE_KEY]}
                        fieldType={TEXT_INPUT}
                        readOnly={isReadonly} 
                    />
                </div>
            </>
        );
    }
}